import type { DataGridColumnSettings } from '@myosh/odin-components';
import { DataGridDataCell } from '@myosh/odin-components';
import type { Ref } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetRecordVersionsQuery } from '../../../redux/services/record';

interface VersionGridActiveCellProps {
  column: DataGridColumnSettings;
  version: number;
  recordId?: number;
}

function VersionGridActiveCell(
  { column, version, recordId }: VersionGridActiveCellProps,
  forwardRef: Ref<HTMLDivElement>
) {
  const { t } = useTranslation();

  const { data: recordVersions } = useGetRecordVersionsQuery(
    { recordId: recordId ?? 0 },
    { skip: recordId === undefined }
  );

  if (recordVersions?.[0].version === version) {
    return <DataGridDataCell ref={forwardRef} value={t('active')} width={column.width} />;
  }

  return null;
}

export default forwardRef(VersionGridActiveCell);
